import { useQuery, useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import API from './utils/api';
import { 
    CreateEmployeeOvertimeEntryDto,
    UpdateEmployeeOvertimeEntryDto,
    QueryEmployeeOvertimeEntryDto,
    EmployeeOvertimeEntryPaginator,
    EmployeeOvertimeEntryDto
} from '../models/employee-overtime-entry.dto';
import ENDPOINTS from './utils/endpoints';

export function useGetEmployeeOvertimeEntry(options?: QueryEmployeeOvertimeEntryDto) {
    const url = ENDPOINTS.HR.EMPLOYEE_OVERTIME_ENTRY.GET;
    const request = (options: QueryEmployeeOvertimeEntryDto) => API.HrAPI.getEmployeeOvertimeEntry(options);

    const { data, isLoading, error, refetch } = useQuery<EmployeeOvertimeEntryPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        { ...API.Handlers.pageParamOption},
    );

    return { data, isLoading, error, refetch };
}

export function useGetEmployeeOvertimeEntryById(id: number){
    const url = ENDPOINTS.HR.EMPLOYEE_OVERTIME_ENTRY.DETAIL;
    const request = API.HrAPI.getEmployeeOvertimeEntryById(id);

    const { data, isLoading, error } = useQuery<{ data: EmployeeOvertimeEntryDto }, Error>(
        [url, id],
        (() => request),
        { enabled: !!(id) },
    );
    
    return { data, isLoading, error };
}


export function useCreateEmployeeOvertimeEntry(onSuccessCallback?: (responsData?: any) => void) {
    const queryClient = useQueryClient();

    return useMutation(
        ({ payload }: { payload: CreateEmployeeOvertimeEntryDto }) => API.HrAPI.createEmployeeOvertimeEntry(payload),
        {
            onSuccess: (response) => {
                if (onSuccessCallback) {
                    onSuccessCallback(response);
                };
            },
            onError: API.Handlers.onErrorHandler,
            onSettled: () => {
                queryClient.invalidateQueries(ENDPOINTS.HR.EMPLOYEE_OVERTIME_ENTRY.GET);
            },
        },
    );
}

export function useUpdateEmployeeOvertimeEntry() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ id, payload }: { id: number, payload: UpdateEmployeeOvertimeEntryDto }) => API.HrAPI.updateEmployeeOvertimeEntry(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
            },
            onError: API.Handlers.onErrorHandler,
            onSettled: () => {
                queryClient.invalidateQueries(ENDPOINTS.HR.EMPLOYEE_OVERTIME_ENTRY.GET);
            },
        },
    );
}

export function useDeleteEmployeeOvertimeEntry() {

    return useMutation(
        ({ id }: { id: number }) => API.HrAPI.deleteEmployeeOvertimeEntry(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}